import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const MeshWifiIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-meshWifi"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M17 18H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V20a2 2 0 0 0-2-2M5 20h12v12H5zm35-2H28a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V20a2 2 0 0 0-2-2m-12 2h12v12H28z"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          d="M3.707 5.707C5.542 3.524 8.09 2 11 2s5.457 1.524 7.293 3.707c.83.986 2.238-.435 1.414-1.414C17.543 1.72 14.407 0 11 0S4.457 1.72 2.293 4.293c-.824.98.584 2.401 1.414 1.414"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          d="M7.707 7.707c.494-.585.947-.98 1.62-1.319A3.85 3.85 0 0 1 11 6a5 5 0 0 1 .456.02l.103.017q.128.025.255.052c.34.08.592.168.81.274.696.341 1.163.745 1.67 1.344.347.413 1.054.36 1.413 0 .41-.409.35-1 0-1.414C14.54 4.911 12.83 4 11 4s-3.54.911-4.707 2.293c-.348.412-.405 1.01 0 1.414.357.357 1.064.414 1.414 0"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M11 14a1 1 0 0 1 .993.883L12 15v4a1 1 0 0 1-1.993.117L10 19v-4a1 1 0 0 1 1-1"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M11 9a3 3 0 1 0-.001 5.999A3 3 0 0 0 11 9m0 2a1 1 0 1 1 .001 1.999A1 1 0 0 1 11 11"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          d="M26.707 5.707C28.542 3.524 31.09 2 34 2s5.457 1.524 7.293 3.707c.83.986 2.238-.435 1.414-1.414C40.543 1.72 37.407 0 34 0s-6.543 1.72-8.707 4.293c-.824.98.584 2.401 1.414 1.414"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          d="M30.707 7.707c.494-.585.947-.98 1.62-1.319A3.85 3.85 0 0 1 34 6a5 5 0 0 1 .456.02l.103.017q.128.025.255.052c.34.08.592.168.81.274.696.341 1.163.745 1.67 1.344.347.413 1.054.36 1.413 0 .41-.409.35-1 0-1.414C37.54 4.911 35.83 4 34 4s-3.54.911-4.707 2.293c-.348.412-.405 1.01 0 1.414.357.357 1.064.414 1.414 0"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M34 14a1 1 0 0 1 .993.883L35 15v4a1 1 0 0 1-1.993.117L33 19v-4a1 1 0 0 1 1-1m23 0a1 1 0 0 1 .993.883L58 15v4a1 1 0 0 1-1.993.117L56 19v-4a1 1 0 0 1 1-1"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M34 9a3 3 0 1 0-.001 5.999A3 3 0 0 0 34 9m0 2a1 1 0 1 1 .001 1.999A1 1 0 0 1 34 11m29 7H51a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V20a2 2 0 0 0-2-2m-12 2h12v12H51z"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          d="M49.707 5.707C51.542 3.524 54.09 2 57 2s5.457 1.524 7.293 3.707c.83.986 2.238-.435 1.414-1.414C63.543 1.72 60.407 0 57 0s-6.543 1.72-8.707 4.293c-.824.98.584 2.401 1.414 1.414"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          d="M53.707 7.707c.494-.585.947-.98 1.62-1.319A3.85 3.85 0 0 1 57 6a5 5 0 0 1 .456.02l.103.017q.128.025.255.052c.34.08.592.168.81.274.696.341 1.163.745 1.67 1.344.347.413 1.054.36 1.413 0 .41-.409.35-1 0-1.414C60.54 4.911 58.83 4 57 4s-3.54.911-4.707 2.293c-.348.412-.405 1.01 0 1.414.357.357 1.064.414 1.414 0"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M57 9a3 3 0 1 0-.001 5.999A3 3 0 0 0 57 9m0 2a1 1 0 1 1 .001 1.999A1 1 0 0 1 57 11m-25 0a1 1 0 0 1 .117 1.993L32 13H14a1 1 0 0 1-.117-1.993L14 11z"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M55 11a1 1 0 0 1 .117 1.993L55 13H37a1 1 0 0 1-.117-1.993L37 11z"
        />
      </g>
    </Icon>
  )
}
